// eslint-disable-next-line import/prefer-default-export
export enum RequestType {
  GET = "get",
  POST = "post",
  PUT = "put",
  PATCH = "patch",
  DELETE = "delete",
}
